<template>
  <div id="hj-container">
    <!-- 
    1、小程序  后端需要给前端一个默认的渠道码
    2、小程序新增器械分类  提供icon  找陈前  
    3、小程序商品详情页  增加器械的资质
    4、小程序首页推荐返回器械
    5、PC全部商品需要一个接口；一个分类的接口 ；
    6、PC全部商品的品牌改为分类
    7、PC 要一个客服电话
    8、PC器械增加资质
    以上是刚才开会的内容 -->
    <header-layout activeIndex="mall"></header-layout>

    <!-- 如果是子路由，只显示子路由内容 -->
    <router-view v-if="$route.name !== 'mall'"></router-view>

    <!-- 商城首页内容 - 只在访问/pc/mall时显示 -->
    <template v-else>
      <div class="mall-container">
        <!-- 顶部搜索栏 -->
        <div class="mall-header">
          <!-- <div class="logo-section">
          <img src="../../../assets/img/home/companyName.png" height="60" alt="陪诊医家" />
          <div class="phone-info">021-62222-120</div>
        </div> -->

          <commonSearch @search="handleSearch" />

          <div class="user-section">
            <div class="user-links">
              <template v-if="!userInfo">
                <span @click="goToLogin">登录/注册</span>
              </template>
              <template v-else>
                <span @click="goToMine">{{ userInfo.mobile | formatMobile }}</span>
              </template>
              <!-- <span @click="goToMine">个人中心</span> -->
              <span @click="goToMine('order')">我的订单</span>
              <span @click="goToMine('collection')">我的收藏</span>
              <span @click="goToService">联系客服</span>
              <div class="cart-info" @click="goToCart"><i class="el-icon-shopping-cart-2"></i>购物车 ({{ cartCount }})</div>
            </div>
          </div>
        </div>

        <!-- 导航标签 -->
        <div class="nav-tabs">
          <div class="nav-container">
            <div :class="['nav-tab', activeTab === 'all' ? 'active' : '']" @click="switchTab('all')">全部商品</div>
            <!-- <div :class="['nav-tab', activeTab === 'shops' ? 'active' : '']" @click="switchTab('shops')">店铺街</div> -->
            <!-- <div :class="['nav-tab', activeTab === 'hot' ? 'active' : '']" @click="switchTab('hot')">热门榜单</div> -->
            <div :class="['nav-tab', activeTab === 'hot' ? 'active' : '']" @click="switchTab('hot')">精品推荐</div>
          </div>
        </div>
        <!-- 主要内容区域 -->
        <div class="mall-content">
          <!-- 左侧分类菜单和轮播图区域 -->
          <div class="main-section">
            <!-- 分类菜单 -->
            <div class="category-menu">
              <div class="category-title">商品分类</div>
              <div class="category-scroll" ref="categoryScroll">
                <div v-for="category in categories" :key="category.id" :class="['category-item', hoveredCategory === category.id ? 'hovered' : '']" @mouseenter="hoveredCategory = category.id" @mouseleave="hoveredCategory = null" @click="viewMore(category)">
                  <span class="category-name">{{ category.name }}</span>
                  <i class="el-icon-arrow-right"></i>

                  <!-- 子分类悬浮框 -->
                  <!-- <div v-if="hoveredCategory === category.id" class="sub-category-popup">
                  <div class="sub-category-content">
                    <div v-for="subCat in category.children" :key="subCat.id" class="sub-category-group">
                      <h4>{{ subCat.name }}</h4>
                      <div class="sub-category-items">
                        <span v-for="item in subCat.items" :key="item.id" @click="goToCategory(item.id)">
                          {{ item.name }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div> -->
                </div>
              </div>
            </div>

            <!-- 轮播图 -->
            <div class="banner-section">
              <el-carousel height="400px" :interval="5000">
                <el-carousel-item v-for="banner in banners" :key="banner.id">
                  <img :src="banner.image" alt="banner" @click="bannerClick(banner)" />
                </el-carousel-item>
              </el-carousel>
            </div>
          </div>

          <!-- 右侧用户信息和快捷入口 -->
          <div class="side-section">
            <div class="user-card">
              <div class="avatar-section">
                <div class="avatar">
                  <img :src="require('../../../assets/img/mall/logo.png')" alt="avatar" style="width: 100%; height: 100%; border-radius: 50%" />
                </div>
                <div class="user-info">
                  <template v-if="userInfo">
                    <div>Hi，{{ userInfo.mobile }}</div>
                    <div class="site-name">欢迎来到因朔桔商城</div>
                  </template>
                  <template v-else>
                    <div>Hi，欢迎来到</div>
                    <div class="site-name">因朔桔商城</div>
                  </template>
                </div>
              </div>
              <div class="user-actions">
                <template v-if="userInfo && userInfo.mobile">
                  <el-button size="small" @click="goToMine">个人中心</el-button>
                  <el-button size="small" type="primary" @click="handleLogout">退出登录</el-button>
                </template>

                <template v-else>
                  <el-button size="small" type="primary" @click="goToLogin">立即登录</el-button>
                </template>
              </div>
            </div>

            <div class="quick-links">
              <div class="link-item">
                <i class="el-icon-s-order"></i>
                <span @click="goToMine('order')">我的订单</span>
              </div>
              <div class="link-item">
                <i class="el-icon-star-off"></i>
                <span @click="goToMine('collection')">我的收藏</span>
              </div>
              <div class="link-item">
                <i class="el-icon-service"></i>
                <span @click="goToService">联系客服</span>
              </div>
            </div>
          </div>
        </div>

        <!-- 商品展示区域 -->
        <div class="products-section">
          <div class="section-title">分类广场</div>

          <!-- 分类展示 -->
          <div v-for="categoryGroup in displayCategories" :key="categoryGroup.id" class="category-section">
            <div class="category-header">
              <h1 class="category-title">{{ categoryGroup.name }}</h1>
              <el-button type="text" @click="viewMore(categoryGroup)">更多 ></el-button>
            </div>

            <div class="category-products">
              <!-- 左侧分类图 -->
              <div class="category-banner" @click="viewMore(categoryGroup)">
                <img :src="categoryGroup.banner" :alt="categoryGroup.name" />
              </div>

              <!-- 右侧商品列表 -->
              <div class="product-grid">
                <product-card v-for="product in categoryGroup.products" :key="product.id" :product="product" @click="goToProduct(product.id, categoryGroup)" />
              </div>
            </div>
          </div>
        </div>

        <!-- 服务承诺 -->
        <div class="service-promise">
          <div class="container">
            <div class="promise-list">
              <div class="promise-item">
                <i class="el-icon-shopping-bag-2"></i>
                <span>品种齐全，购物轻松</span>
              </div>
              <div class="promise-item">
                <i class="el-icon-truck"></i>
                <span>多仓直发，极速配送</span>
              </div>
              <div class="promise-item">
                <i class="el-icon-box"></i>
                <span>正品行货，精致服务</span>
              </div>
              <div class="promise-item">
                <i class="el-icon-money"></i>
                <span>天天低价，畅选无忧</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <footer-layout></footer-layout>
    </template>

    <!-- 登录弹框 -->
    <login-dialog v-if="loginDialogVisible" v-model="loginDialogVisible" @login-success="handleLoginSuccess" @register-success="handleRegisterSuccess" />

    <!-- 客服弹框 -->
    <el-dialog title="联系客服" :visible.sync="serviceDialogVisible" width="400px" custom-class="service-dialog" :show-close="true">
      <div class="service-content">
        <!-- <h2 class="dialog-title">联系客服</h2> -->
        <div class="service-info">
          <i class="el-icon-headset service-icon"></i>
          <div class="contact-info">
            <h3>客服热线</h3>
            <p class="phone-number">4001069667</p>
            <div class="service-time">
              <p>服务时间：周一至周五</p>
              <p>9:00-18:00</p>
            </div>
          </div>
        </div>
        <el-button type="primary" plain class="close-btn" @click="serviceDialogVisible = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import HeaderLayout from '@/components/pc/HeaderLayout.vue'
import FooterLayout from '@/components/pc/FooterLayout.vue'
import commonSearch from './components/commonSearch.vue'
import ProductCard from './components/ProductCard.vue'
import LoginDialog from './components/LoginDialog.vue'
import mall from '@/api/mall'
import loginApi from '@/api/login'
import { Session } from '@/utils/storage'

export default {
  name: 'MallIndex',
  components: {
    HeaderLayout,
    FooterLayout,
    commonSearch,
    ProductCard,
    LoginDialog
  },
  data() {
    return {
      cartCount: 0,
      activeTab: 'all',
      hoveredCategory: null,
      serviceDialogVisible: false,
      loginDialogVisible: false,
      userInfo: null,
      categories: [],
      banners: [
        {
          id: 1,
          image: require('../../../assets/img/mall/banner-1.png'),
          link: '/pc/mall/category/1'
        },
        {
          id: 2,
          image: require('../../../assets/img/mall/banner-2.png'),
          link: '/pc/mall/category/2'
        },
        {
          id: 3,
          image: require('../../../assets/img/mall/banner-3.png'),
          link: '/pc/mall/category/3'
        }
      ],
      displayCategories: [
        {
          id: 613,
          name: '检验器械',
          banner: require('../../../assets/img/mall/qixie.png'),
          products: []
        },
        {
          id: 378,
          name: '感冒用药',
          banner: require('../../../assets/img/mall/ganmao.png'),
          products: []
        },
        {
          id: 377,
          name: '滋补调养',
          banner: require('../../../assets/img/mall/baojian.png'),
          products: []
        }
      ]
    }
  },
  computed: {
    username() {
      return Session.get('userInfo') ? Session.get('userInfo').userName : ''
    }
  },
  created() {
    this.initUserInfo()
    //获取【商品分类】
    this.getCategoryList()
    //获取【分类广场商品列表】
    this.getPartProductList()
  },
  mounted() {
    console.log('mounted')
    this.initUserInfo()
  },
  watch: {
    // 监听路由参数变化
    '$route.query._t': {
      handler() {
        this.initUserInfo()
      }
    }
  },
  methods: {
    initUserInfo() {
      this.userInfo = Session.get('userInfo') || {}
      console.log('initUserInfo', this.userInfo)
    },
    handleLoginSuccess() {
      this.initUserInfo()
      this.loginDialogVisible = false
    },
    handleRegisterSuccess() {
      this.initUserInfo()
      this.loginDialogVisible = false
    },
    handleLogout() {
      Session.clear()
      this.userInfo = null
      this.$message.success('退出登录成功')
    },
    goToLogin() {
      this.loginDialogVisible = true
    },
    // 获取品类列表
    getCategoryList() {
      const params = {
        channelCode: this.$local.get('channelCode')
      }
      mall.getCategoryList(params).then((res) => {
        this.categories = res.data.data
      })
    },
    //获取【分类广场商品列表】
    getPartProductList() {
      const ids = this.displayCategories.map((item) => item.id)
      ids.forEach((id, index) => {
        const params = {
          frontCateId: id, //前端类目ID
          pageNumber: 1, //页码
          pageSize: 6, //页大小
          channelCode: this.$local.get('channelCode')
        }
        mall.getProductCategoryList(params).then((res) => {
          this.displayCategories[index].products = res.data.data
        })
      })
    },
    handleSearch(keyword) {
      this.$router.push({ path: '/pc/mall/allProducts', query: { keyword } })
      // 这里实现搜索逻辑
    },
    switchTab(tab) {
      this.activeTab = tab
      if (tab === 'all') {
        this.$router.push('/pc/mall/allProducts')
      } else if (tab === 'hot') {
        this.$router.push('/pc/mall/hotProducts')
      }
    },
    goToProduct(productId, categoryGroup) {
      console.log('商品ID:', categoryGroup)
      this.$router.push({
        path: `/pc/mall/product/${productId}`,
        query: {
          categoryName: categoryGroup.name,
          categoryId: categoryGroup.id
        }
      })
    },
    viewMore(category) {
      this.$router.push(`/pc/mall/category/${category.id}/${category.name}`)
    },
    bannerClick(banner) {
      if (banner.link) {
        this.$router.push(banner.link)
      }
    },
    goToMine(tab) {
      //判断是否登录
      if (!this.userInfo || !this.userInfo.mobile) {
        this.loginDialogVisible = true
        return
      }
      this.$router.push(`/pc/mall/mine?tab=${tab}`)
    },
    goToService() {
      this.serviceDialogVisible = true
    },
    // callService() {
    //   window.location.href = 'tel:029-84190239'
    // },
    goToCart() {
      this.$router.push('/pc/mall/cart')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../assets/css/variables.scss';

.mall-header {
  background: #fff;
  padding: 10px 0;
  border-bottom: 1px solid #e5e5e5;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  max-width: 1200px;
  margin: 0 auto;

  .logo-section {
    display: flex;
    flex-direction: column;
    align-items: center;

    .phone-info {
      font-size: 12px;
      color: #666;
      margin-top: 5px;
    }
  }

  .user-section {
    text-align: right;

    .user-links {
      font-size: 12px;
      margin-bottom: 10px;
      display: flex;
      align-items: center;

      span {
        margin-left: 15px;
        color: #666;
        cursor: pointer;

        &:hover {
          color: #409eff;
        }
      }
    }

    .cart-info {
      margin-left: 15px;
      color: #409eff;
      // font-size: 16px;
      cursor: pointer;

      i {
        margin-right: 5px;
      }
    }
  }
}

.mall-content {
  max-width: 1200px;
  margin: 20px auto;
  display: flex;
  gap: 20px;

  .main-section {
    flex: 1;
    display: flex;
    position: relative;

    .category-menu {
      width: 200px;
      // background: #f8f9fa;
      position: absolute;
      left: 0;
      top: 0;
      z-index: 10;
      height: 400px;

      .category-title {
        background: #409eff;
        color: white;
        padding: 15px 20px;
        font-weight: bold;
        font-size: 16px;
      }

      .category-scroll {
        height: 346px;
        overflow-y: auto;
        background: rgba(0, 0, 0, 0.4);
        color: #fff;

        &::-webkit-scrollbar {
          width: 6px;
        }

        &::-webkit-scrollbar-thumb {
          background: rgba(0, 0, 0, 0.1);
          border-radius: 3px;
        }

        &::-webkit-scrollbar-thumb:hover {
          background: rgba(0, 0, 0, 0.1);
        }

        &::-webkit-scrollbar-track {
          background: rgba(0, 0, 0, 0.1);
        }
      }

      .category-item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 12px 20px;
        cursor: pointer;
        // border-bottom: 1px solid #eee;
        position: relative;

        &:hover,
        &.hovered {
          background: #409eff;
          color: white;
        }

        .category-name {
          font-size: 14px;
        }

        .sub-category-popup {
          position: absolute;
          left: 100%;
          top: 0;
          width: 400px;
          background: white;
          border: 1px solid #ddd;
          box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.1);
          z-index: 100;

          .sub-category-content {
            padding: 20px;

            .sub-category-group {
              margin-bottom: 20px;

              h4 {
                color: #333;
                margin-bottom: 10px;
                font-size: 14px;
              }

              .sub-category-items {
                span {
                  display: inline-block;
                  margin-right: 15px;
                  margin-bottom: 8px;
                  color: #666;
                  font-size: 12px;
                  cursor: pointer;

                  &:hover {
                    color: #409eff;
                  }
                }
              }
            }
          }
        }
      }
    }

    .banner-section {
      flex: 1;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        cursor: pointer;
      }
    }
  }

  .side-section {
    width: 300px;

    .user-card {
      background: white;
      border: 1px solid #e5e5e5;
      border-radius: 8px;
      padding: 20px;
      margin-bottom: 20px;

      .avatar-section {
        display: flex;
        align-items: center;
        margin-bottom: 15px;

        .avatar {
          width: 50px;
          height: 50px;
          border-radius: 50%;
          background: #f0f0f0;
          margin-right: 15px;
        }

        .user-info {
          .site-name {
            font-weight: bold;
            color: #333;
          }
        }
      }

      .user-actions {
        text-align: center;
        transform: translateX(-15px);

        .el-button {
          margin: 0 5px;
        }
      }
    }

    .quick-links {
      background: white;
      border: 1px solid #e5e5e5;
      border-radius: 8px;

      .link-item {
        display: flex;
        align-items: center;
        padding: 15px 20px;
        border-bottom: 1px solid #f0f0f0;
        cursor: pointer;

        &:last-child {
          border-bottom: none;
        }

        &:hover {
          background: #f8f9fa;
        }

        i {
          margin-right: 10px;
          color: #409eff;
        }
      }
    }
  }
}

.nav-tabs {
  background: white;
  border-bottom: 1px solid #e5e5e5;

  .nav-container {
    max-width: 1200px;
    margin: 0 auto;
    display: flex;

    .nav-tab {
      padding: 15px 30px;
      cursor: pointer;
      border-bottom: 3px solid transparent;
      transition: all 0.3s;

      &:hover {
        color: #409eff;
      }

      &.active {
        color: #409eff;
        border-bottom-color: #409eff;
      }
    }
  }
}

.products-section {
  max-width: 1200px;
  margin: 30px auto;

  .section-title {
    font-size: 24px;
    font-weight: bold;
    margin-bottom: 30px;
    color: #333;
    background-image: url('https://peizhenyijia.com/pc/img/classified-title.2fcd2dc.png');
    background-size: 100%;
    background-position: 50%;
    background-repeat: no-repeat;
    text-align: center;
  }

  .category-section {
    margin-bottom: 50px;

    .category-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 20px;
      .category-title {
        font-size: 20px;
        color: #333;
        margin: 0;
        font-weight: bold;
      }

      h3 {
        font-size: 18px;
        color: #333;
        margin: 0;
      }
    }

    .category-products {
      display: flex;
      gap: 20px;

      .category-banner {
        width: 224px;
        height: 540px;
        img {
          width: 100%;
          height: 100%;
          object-fit: fill;
          border-radius: 8px;
        }
      }

      .product-grid {
        flex: 1;
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        gap: 20px;
        padding: 0 20px;
      }
    }
  }
}

/* 客服弹框样式 */
::v-deep .service-dialog {
  border-radius: 10px;
  .el-dialog__header {
    display: none;
  }

  .el-dialog__body {
    padding: 0;
  }

  .service-content {
    padding: 30px 20px;
    text-align: center;

    .dialog-title {
      font-size: 24px;
      color: $text-primary;
      margin: 0 0 10px 0;
      font-weight: normal;
    }

    .service-info {
      // background: #fff6f2;
      border-radius: 12px;
      padding: 20px 20px;
      margin-bottom: 30px;

      .service-icon {
        font-size: 28px;
        color: #409eff;
        margin-bottom: 20px;
      }

      .contact-info {
        h3 {
          font-size: 16px;
          color: $text-primary;
          margin: 0 0 15px 0;
          font-weight: normal;
        }

        .phone-number {
          font-size: 32px;
          color: #409eff;
          font-weight: bold;
          margin: 0 0 20px 0;
        }

        .service-time {
          color: $text-regular;
          font-size: 14px;
          line-height: 1.8;

          p {
            margin: 0;
          }
        }
      }
    }

    .close-btn {
      width: 180px;
      height: 40px;
      // border: 1px solid $primary-color;
      // color: $primary-color;
      font-size: 16px;
      border-radius: 20px;
      padding: 0;

      &:hover {
        // background: $primary-light-bg;
      }
    }
  }

  .el-dialog__footer {
    display: none;
  }
}

/* 登录弹框样式 */
::v-deep .login-dialog {
  .el-dialog__header {
    padding: 0;
    .el-dialog__headerbtn {
      z-index: 1;
      .el-dialog__close {
        color: #666;
      }
    }
  }

  .login-content {
    padding: 0 40px;

    .login-header {
      text-align: center;
      margin-bottom: 20px;

      .login-logo {
        width: 80px;
        margin-bottom: 15px;
      }
    }

    .login-tabs {
      .el-tabs__nav-wrap::after {
        height: 1px;
      }

      .el-tabs__item {
        font-size: 16px;
        height: 45px;
        line-height: 45px;

        &.is-active {
          color: $primary-color;
        }
      }

      .el-tabs__active-bar {
        background-color: $primary-color;
      }
    }

    .login-form {
      margin-top: 20px;

      .el-input {
        margin-bottom: 5px;

        ::v-deep .el-input__inner {
          height: 45px;
          line-height: 45px;
          border-radius: 4px;

          &:focus {
            border-color: $primary-color;
          }
        }

        ::v-deep .el-input__prefix {
          font-size: 18px;
          color: #999;
        }
      }

      .form-footer {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 10px 0 20px;

        .el-checkbox {
          color: #666;
        }

        .forget-pwd {
          color: #666;
          &:hover {
            color: $primary-color;
          }
        }
      }

      .login-btn {
        width: 100%;
        height: 45px;
        font-size: 16px;
        margin-bottom: 15px;

        &:hover,
        &:focus {
          background: $primary-hover-color;
          border-color: $primary-hover-color;
        }
      }
    }
  }
}

/* 搜索组件样式 */
::v-deep .common-search {
  .el-input-group__append {
    background: $primary-color;
    border-color: $primary-color;

    .el-button {
      color: white;
      border: none;

      &:hover,
      &:focus {
        background: $primary-hover-color;
        color: white;
      }
    }
  }

  .quick-search {
    span {
      &:hover {
        color: $primary-color;
      }
    }
  }
}

.service-promise {
  background: #fff;
  padding: 30px 0;
  border-top: 1px solid #eee;
  margin-top: 40px;

  .container {
    max-width: 1200px;
    margin: 0 auto;
  }

  .promise-list {
    display: flex;
    justify-content: space-around;
    align-items: center;
    font-weight: bold;
  }

  .promise-item {
    display: flex;
    align-items: center;
    color: #666;

    i {
      font-size: 24px;
      margin-right: 10px;
      color: #666;

      &:hover {
        color: #409eff;
      }
    }

    span {
      font-size: 16px;
    }
    transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    &:hover {
      transform: scale(1.3);
      color: #409eff !important;
      i {
        color: #409eff !important;
      }
    }
  }
}
</style>
